import { Autocomplete, Grid, TextField, Typography } from "@mui/material";
import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { useStyle } from "../style";
import dayjs from "dayjs";
import _ from "lodash";
import moment from "moment";
import { setSnackbar } from "../../../../../../components/hooks/snackBar/reducers";
import CustomTable from "../../customTable";
import { Helmet } from "react-helmet-async";

const StockLedger = () => {
  const classes = useStyle()
  const dispatch = useDispatch();
  const pageOption = [10, 25, 50, 100];
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(100);
  // const [rowsPerPage, setRowsPerPage] = useState(pageOption[0]);
  const [pageCount, setPageCount] = useState(0);
  const [data, setData] = useState([]);
  const [supplier, setSupplier] = useState([]);
  const[cust, setCust] = useState(null)
  const [dateLimit, setDateLimit] = useState({
    fromDate : moment().subtract(1 , 'months').format(),
    toDate : moment().format()
  })
  const [totalAmount , setTotalAmount] = useState(0) // overall amount in footer
  const [totalFlag , setTotalFlag] = useState(false) // set the total flag true
const columns = [
  {
    field : 'sno',
    headerName : 'S.no',
    minWidth : 70,
    headerAlign : 'center',
    align : 'center',
    sortable: false
  },
  // {
  //   field: "date1",
  //   headerName: "Date",
  //   flex: 1,
  //   headerAlign: "center",
  //   align: "center",
  //   sortable: false,
  // },
  {
    field: "ProCode",
    headerName: "Product Code",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "party",
    headerName: "Product Name",
    flex:1,
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "sales",
    headerName: "Sales",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "salesReturn",
    headerName: "Sales Return",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "purchase",
    headerName: "Purchase",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "pur_rate",
    headerName: "Purchase Rate",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "wastage",
    headerName: "Wastage",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "trIn",
    headerName: "Tr In",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "trOut",
    headerName: "Tr Out",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "closing",
    headerName: "Closing",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
 
  {
    field: "rate",
    headerName: "Rate",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "value",
    headerName: "Value",
    minWidth: 130,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "balance",
    headerName: "Balance",
    minWidth: 130,
    headerAlign: "center",
    align: "right",
    sortable: false,
    renderCell: (params) => (
      <strong>{params.value}</strong>
    ),
  },
]

const rows = _.map(data,(val,idx)=>({
  id: idx+1,
  sno: idx+1,
  date1 : val.docdate,
  ProCode : val.pro_code,
  party : val.pro_name,
  sales:parseFloat(val.sales).toFixed(0),
  salesReturn:parseFloat(val.salesreturn).toFixed(0),
  purchase:parseFloat(val.purchase).toFixed(0),
  pur_rate:parseFloat(val.pur_rate).toFixed(0),
  closing:parseFloat(val.closing).toFixed(0),
  balance:val.balance === null ? 0.00 : parseFloat(val.balance).toFixed(0),
  wastage:parseFloat(val.waste).toFixed(0),
  trIn:parseFloat(val.tr_in_qty).toFixed(0),
  trOut:parseFloat(val.tr_out_qty).toFixed(0),
  rate:parseFloat(val.pur_rate).toFixed(0),
  value: (val.balance * val.pur_rate)
}))
const props = {
  columns : columns,
  rows : rows,
  page: page,
  setPage: setPage,
  rowsPerPage: rowsPerPage,
  setRowsPerPage: setRowsPerPage,
  pageCount: pageCount,
  pageOption: pageOption,
  totalAmount:totalAmount,
  totalFlag:totalFlag
}
useEffect(() => {
  // Calculate total balance amount
  setTotalFlag(true)
  let total = 0;

  data.forEach(val => {
      total += parseFloat(val.balance === null ? 0.00 : parseFloat(val.balance).toFixed(0));
  });
  setTotalAmount(total.toFixed(0));
}, [data]);
  function handleChange(e, name) {
    setDateLimit(prev=>({...prev,[name] : dayjs(e).format() }))
  }
  function getSupplierData() {
    axios
      .get("/v1/categories")
      .then((res) => {
        setSupplier(res.data);
      })
      .catch((err) => {
        dispatch(setSnackbar(true, "error", err.response.error));
      });
  }
function handleStockReport(){
  const postData = {
    from_date:moment(dateLimit.fromDate).format('YYYY-MM-DD'),
    to_date:moment(dateLimit.toDate).format('YYYY-MM-DD'),
    category: cust !== null ? cust.id : 0
  }
  console.log(postData)
  axios.post('/v1/reports/stock/ledger', postData)
  .then(res=>{
    setData(res.data)
    setPageCount(res.data.length)
  })
  .catch(err=>{
    dispatch(setSnackbar(true, "error", "No data Found"));
    setData([])
  })
  // err.response.data.errors[0].message
}
  useEffect(() => {
    getSupplierData();
  }, []);
  console.log(dateLimit, cust)
  useEffect(()=>{
    if(dateLimit.fromDate!==null && dateLimit.toDate!==null){
      handleStockReport()
    }
  },[rowsPerPage, page, dateLimit, cust])
  console.log(cust)

  return (
    <Fragment>
      <Helmet><title>Stock Ledger</title></Helmet>
      <Typography variant="h6">Stock Ledger</Typography>
      <Grid container spacing={2} className="p-2 pt-2">
        <Grid item md={3}>
          <Autocomplete 
            size="small"
            options={supplier}
            onChange={(e,value)=>setCust(value)}
            getOptionLabel={option=>option.category_name}
            renderInput={(params) => <TextField {...params} label="Categories"/>}
          />
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "fromDate")}
              value={dayjs(dateLimit.fromDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'From',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item md={3}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DatePicker
              onChange={(e) => handleChange(e, "toDate")}
              value={dayjs(dateLimit.toDate)}
              format='DD-MM-YYYY'
              slotProps={{
                textField: {
                  size: "small",
                  label:'To',
                  style:{width : '100%'}
                },
              }}
            />
          </LocalizationProvider>
        </Grid>
      </Grid>
      <CustomTable props={props}/>
    </Fragment>
  );
};
export default StockLedger;
